export default "__VITE_ASSET__u4cOqjCS__"